import { ReplaySubject, Observable } from 'rxjs';
import { DateRange } from '@vendasta/uikit';
import { filter, map } from 'rxjs/operators';

export interface DateFilterServiceInterface {
  dateRange$: Observable<DateRange>;

  setDateRange(startDate: Date, endDate: Date): void;
  clearSelection(): void;
}

class DateFilterService implements DateFilterServiceInterface {
  private dateRange$$ = new ReplaySubject<DateRange>(1);
  dateRange$ = this.dateRange$$.asObservable();
  dateFilterToString$: Observable<string> = this.dateRange$.pipe(
    filter((dateRange: DateRange) => !!dateRange?.start && !!dateRange?.end),
    map((dateRange: DateRange) => dateRange.start.toLocaleDateString() + ' - ' + dateRange.end.toLocaleDateString()),
  );

  setDateRange(startDate: Date, endDate: Date): void {
    if (startDate != null && endDate != null) {
      this.dateRange$$.next({ start: startDate, end: endDate });
    }
  }

  clearSelection(): void {
    this.dateRange$$.next(null);
  }
}

export class ExpectedCloseFilterService extends DateFilterService {}
export class ActualCloseFilterService extends DateFilterService {}
export class CreatedDateFilterService extends DateFilterService {}
export class AssignedDateFilterService extends DateFilterService {}
